import React from "react";

const SelectField = ({ value, onChange, options, required }) => {
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      required={required}
      className="select-field"
    >
      <option value="">선택하세요</option>
      {options &&
        options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
    </select>
  );
};

export default SelectField;
